import { Utils } from '../helpers/utils';
import { Pcategory } from './pcategory';

export class Poptional {
	id: number;
	pcategory_id: number;

	name: string;
	min_qty: number;
	max_qty: number;
	un_price: string;
	hidden: boolean;
	local_id: number;
	individual: boolean;

	// display order
	display_order: string;

	//timestamps
	created_at: string;
	updated_at: string;

	// relationships
	subpoptionals: Subpoptional[];
	pcategory: Pcategory;
	priceNumber: number;

	// set by our front end app
	index: number;
	parsedDisplayOrder: {
		index: number,
		subpoptionals: {
			id: number,
			name?: string,
			index: number,
			local_id: number
		}[];
	}

	constructor(json: any) {
		for(let prop in json) {
			if(prop == "subpoptionals") {
				this.subpoptionals = Subpoptional.fromJsonArray(json.subpoptionals);
			} else {
				this[prop] = json[prop];
			}
		}
		if(!this.subpoptionals) {
			this.subpoptionals = [];
		}
		this.priceNumber = Number(this.un_price || '0');
		this.setDisplayOrder();
	}

	choiceTitle(itemQty: number = 1): string {
		if(!this.individual) {
			itemQty = 1;
		}

		let min = (this.min_qty || 0) * itemQty;
		let max = this.max_qty == null ? null : this.max_qty * itemQty;
		if(max != null && min == max) {
			if(min <= 1) {
				return min == 1 ? 'Escolha 1 opção' : '';
			}
			return `Escolha ${min} opções`;
		}

		let res = 'Escolha';
		if(min > 0) {
			res += ` de ${min}`;
		}
		if(max != null && max > 0) {
			res += ` até ${max}`;
		}

		return res + (max == 1 ? " opção" : " opções");
	}

	setDisplayOrder() {
		if(!this.display_order) {
			this.index = 100;
			return;
		}

		try {
			this.parsedDisplayOrder = JSON.parse(this.display_order);
		} catch (e) {
			this.index = 100;
			return;
		}
		this.index = this.parsedDisplayOrder.index || 0;
		if(this.parsedDisplayOrder.subpoptionals && this.subpoptionals) {
			for(let subp of this.parsedDisplayOrder.subpoptionals) {
				let subpoptional: Subpoptional =
					Utils.findById(subp.local_id || subp.id, this.subpoptionals, 'local_id')
					|| Utils.findById(subp.id, this.subpoptionals)
					|| Utils.findById(subp.name, this.subpoptionals, 'name');
				if(subpoptional) {
					subpoptional.index = subp.index;
				}
			}
			this.subpoptionals = this.subpoptionals.sort((a, b) => (a.index || 0) - (b.index || 0));
		}
	}

	static fromJsonArray(poptionals: Poptional[]): Poptional[] {
		let res = [];
		if(!poptionals) {
			return res;
		}
		for(let popt of poptionals) {
			res.push(new Poptional(popt));
		}
		return res.sort((a,b) => (a.index || 0) - (b.index || 0));
	}
}
export class Subpoptional {
	id: number;
	poptional_id: number;

	name: string;
	min_qty: number;
	max_qty: number;
	un_price: string;
	hidden: boolean;
	local_id: number;

	// timestamps
	created_at: string;
	updated_at: string;

	// set by our front end app
	priceNumber: number;
	index: number;

	constructor(json: any) {
		for(let prop in json) {
			this[prop] = json[prop];
		}
		this.priceNumber = Number(this.un_price || '0');
	}

	static fromJsonArray(subpoptionals: any[]): Subpoptional[] {
		let res = [];
		if(!subpoptionals) {
			return res;
		}
		for(let subp of subpoptionals) {
			let aux = new Subpoptional(subp);
			if(!aux.hidden) {
				res.push(aux);
			}
		}
		return res;
	}
}
